(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    

// Custom variant select - changes form hidden input value to radio value which is the variant id

const variant_radios = document.querySelectorAll('.variant-select input');

variant_radios.forEach(variant_radio => {
  variant_radio.addEventListener("click", function() {
    document.querySelector('.btn-add-to-bag__form input[data-add-to-cart-id]').value = variant_radio.value;
    document.querySelector('.btn-add-to-bag__quantity-input').value = 1;
  })
});

// Product gallery swipers

addEventListener('DOMContentLoaded', () => {

  var swiper = new Swiper(".thumbSwiper", {
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
    direction: "horizontal",
    loop: false,
    breakpoints: {
        1024: {
          slidesPerView: 4,
          direction: "vertical",
        },
      },
  });
  var swiper2 = new Swiper(".mainSwiper", {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    spaceBetween: 10,
    zoom: true,
    thumbs: {
      swiper: swiper,
    },
    on: {
      init: function() {
        var main_swiper_slide = document.querySelector('.main-swiper');
        var thumb_swiper_slide = document.querySelector('.swiper-slide.thumb');
        var thumb_swiper = document.querySelector('.thumbSwiper');

        var main_swiper_width = main_swiper_slide.offsetWidth;
        var thumb_swiper_width = thumb_swiper_slide.offsetWidth;

        main_swiper_slide.style.height = main_swiper_width + 'px';

        if ($(window).width() > 1023.98) {
          thumb_swiper.style.height = main_swiper_width + 'px';
        } else {
          thumb_swiper.style.height = thumb_swiper_width + 'px';
        }

        document.querySelector('.gallery-container').style.opacity = 1;

        addEventListener('resize', () => {
          var main_swiper_slide = document.querySelector('.main-swiper');
          var thumb_swiper_slide = document.querySelector('.swiper-slide.thumb');
          var thumb_swiper = document.querySelector('.thumbSwiper');

          var main_swiper_width = main_swiper_slide.offsetWidth;
          var thumb_swiper_width = thumb_swiper_slide.offsetWidth;

          main_swiper_slide.style.height = main_swiper_width + 'px';

          if ($(window).width() > 1023.98) {
            thumb_swiper.style.height = main_swiper_width + 'px';
          } else {
            thumb_swiper.style.height = thumb_swiper_width + 'px';
          }
        });

      }
    },
  });
  if (document.querySelector('.productUpsellList')) {
      var productUpsell = new Swiper(".productUpsellList", {
        spaceBetween: 15,
        slidesPerView: 2,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
            1024: {
              slidesPerView: 3,
            },
          },
      });
    }
});

  } catch(e) { console.error(e); }
})();
})();
